import styled from "styled-components";

export const OtherReasonWrap = styled.div`
  margin: 0 auto;
  background-color: #0C1A53;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0 40px;
`;

export const AreaWrap = styled.div`
  width: 54.22%;
  margin: 0 auto;
`;

export const TextImg = styled.div`
  margin: 0 auto;
  width: 100%; 
  padding-top: 18.146%;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
`;

export const Textarea = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 2px;
  width: 83.09%;

  > textarea {
    padding: 10px 16px;
    margin-top: 24px;
    height: 168px;
    border: 1px solid #EDEDED;
    font-size: 22px;
    font-weight: 400;
    line-height: 38px;
    resize: none;

    @media only screen and (max-width: 640px) {
      font-size: 14px;
      line-height: 24px
    }
  }

  > div {
    margin-top: 8px;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #979797;
    align-self: flex-end;
  }
`;

export const SubmitWrap = styled.div`
  background-color: #0C1A53;
  padding: 32px 0 60px;
`;

export const SubmitImg = styled.button`
  width: 83.09%;
  margin: 0 auto;
  display: flex;
  padding-top: 21.168%; 
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: contain; 
  border: none;
  outline: none;
`;
